import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BeachSite } from 'src/app/models/BeachSite';
import { PollutionForecastTypes } from '../../models/app-constants';
import { AppMonitoringService } from 'src/app/services/logging.service';


@Component({
	selector: 'app-site-link',
	templateUrl: './site-link.component.html',
	styleUrls: ['./site-link.component.scss'],
})

export class SiteLinkComponent implements OnInit {
	@Input() site: BeachSite;
	public imgUrl: string;
	public imgClass : string;
	public divClass : string;

	@Output() siteLinkClickedEvent : EventEmitter<BeachSite> = new EventEmitter<BeachSite>();

	constructor(private appMonitoringService: AppMonitoringService) {}

	ngOnInit(): void {
		switch (this.site.PollutionForecast) 
		{
		case PollutionForecastTypes.POLLUTION_UNLIKELY:
			this.imgUrl = 'assets/images/WaterqualityForecastIndicator/Green.svg';
			this.imgClass = 'unlikely';
			this.divClass = 'gi-icon-unlikely';
			break;
		case PollutionForecastTypes.POLLUTION_POSSIBLE:
			this.imgUrl = 'assets/images/WaterqualityForecastIndicator/Yellow.svg';
			this.imgClass = 'possible';
			this.divClass = 'gi-icon-possible';
			break;
		case PollutionForecastTypes.POLLUTION_LIKELY:
			this.imgUrl = 'assets/images/WaterqualityForecastIndicator/Red.svg';
			this.imgClass = 'likely';
			this.divClass = 'gi-icon-likely';
			break;
		default:
			this.imgUrl = 'assets/images/WaterqualityForecastIndicator/Unavailable.svg';
			this.imgClass = 'unavailable';
			this.divClass = 'gi-icon-unavailable';
			break;
		}
	}

	getClass(pollForecastDesc: string) {
		if ('Pollution Unlikely' === pollForecastDesc) 
		{
			return 'gi-icon-unlikely';
		}
		else if('Data Unavailable' === pollForecastDesc) {
			return 'gi-icon-unavailable';
		}
		else if (pollForecastDesc === 'Pollution Likely') {
			return 'gi-icon-likely';
		} else if (pollForecastDesc === 'Pollution Possible') {
			return 'gi-icon-possible';
		} 
		else 
		{
			return '';
		}
	}

	onSiteLinkClicked(event : MouseEvent) 
	{
		this.appMonitoringService.logEvent('PopupOpenFromMapSiteList',{'site_identifier': this.site.Identifier})
		this.siteLinkClickedEvent.emit(this.site);
	}

	onSiteDetailsNavigation(id: any){
		this.appMonitoringService.logEvent('SiteDetailsLoadFromMapSiteList',{'site_identifier': id})
	}
}
